import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  getCommissionPlans(params) {
    return axios.get(adminPath('/commission_plans?') + prepareQueryString(params)).then((response) => {
      return {
        commissionPlans: response.data.map((commissionPlan) => an('CommissionPlan', commissionPlan)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  get(id) {
    return axios.get(adminPath(`/commission_plans/${id}`)).then((response) => an('CommissionPlan', response.data));
  },
  update(id, data) {
    return axios
      .patch(adminPath(`/commission_plans/${id}`), {
        ...data,
      })
      .then((response) => an('CommissionPlan', response.data));
  },
  create(data) {
    return axios
      .post(adminPath('/commission_plans'), {
        ...data,
      })
      .then((response) => an('CommissionPlan', response.data));
  },
  getSpreadsheet(params) {
    return axios.get(adminPath('/commission_plans.csv?') + prepareQueryString(params), { responseType: 'blob' });
  },
};
